import api from "./axiosInstance";

export const getArtists = async () => {
  const res = await api.get("api/v1/artists/");
  return res.data;
};

export const getAllArtists = async () => {
  const res = await api.get("api/v1/artists/?limit===999");
  return res.data;
};

export const getArtistById = async (id) => {
  const res = await api.get(`api/v1/artists/${id}/`);
  return res.data;
};

export const getArtistCalendar = async (artistId, year, month) => {
  const res = await api.get(`api/v1/artists/${artistId}/calendar/`, {
    params: { year, month },
  });
  return res.data;
};

export const createArtist = async (payload) => {
  const res = await api.post(`api/v1/artists/`, payload);
  return res.data;
};

export const updateArtist = async (id, payload) => {
  const res = await api.patch(`api/v1/artists/${id}/`, payload);
  return res.data;
};

export const searchEventArtists = async (searchTerm) => {
  const res = await api.get(`api/v1/event-artists/`, {
    params: { search: searchTerm },
  });
  return res.data;
};

export const createEventArtist = async (payload) => {
  const res = await api.post(`api/v1/event-artists/`, payload);
  return res.data;
};
